<template>
  <div class="mb001">
    <div v-if="isEmergency" class="emergency">
      <div class="inner container">
        <BadgeIcon class="-md -requires">
          <!--<img src="@/assets/images/icons/exclamation.svg" class="icon" />-->
          緊急のお知らせ
        </BadgeIcon>
        <div class="messages">
          <span
            v-for="(item, index) of urgentList"
            :key="'urgent' + index"
            class="message"
          >
            <template v-if="item.url">
              <a :href="item.url" class="link" target="_blank">
                <span class="date">{{ item.display_date }}</span>
                {{ item.title }}
              </a>
            </template>
            <template v-else>
              <span class="date">{{ item.display_date }}</span>
              {{ item.title }}
            </template>
          </span>
        </div>
      </div>
    </div>
    <div class="message">
      <div class="inner container">
        <CardBox>
          <CardHeader>
            <h2 class="heading">
              <span class="name">{{ coveredName }}</span> さま
            </h2>
            <span class="number"
              >お客さま番号：{{ membersIndex.account_id }}</span
            >
          </CardHeader>
          <CardBox>
            <CollapseItem
              id="accordion0"
              accordion="accordion0"
              :visible="true"
            >
              <CardBody>
                <ListGroup class="-link -visited _mb-md-30 _mb-sm-15">
                  <ListItem
                    v-for="notice of membersIndex.notices.slice(0, 3)"
                    :key="notice.notice_id"
                    class="-link"
                    :class="{ unread: notice.disp_status === '0' }"
                    router-name="mb003"
                    :params="{ notice_id: notice.notice_id }"
                  >
                    {{ notice.notice_title }}
                  </ListItem>
                </ListGroup>
                <div class="button _pb-md-30 _pb-sm-15">
                  <BtngroupSingle>
                    <BtnMain class="-normal" router-name="mb002">
                      メッセージ一覧
                    </BtnMain>
                  </BtngroupSingle>
                </div>
              </CardBody>
            </CollapseItem>
            <CardHeader>
              <BtnToggle collapse-target="accordion0" class="-plus">
                <h2 class="heading">
                  <span class="new"
                    >新着メッセージ<span class="count"
                      >{{ newMessageCount }}件</span
                    ></span
                  >
                  <span class="close">閉じる</span>
                </h2>
              </BtnToggle>
            </CardHeader>
          </CardBox>
        </CardBox>
      </div>
    </div>
    <div class="container main">
      <h2 class="stat _mb-30">ご利用状況</h2>
      <div class="row _mb-50">
        <div class="col-md-6 col-12">
          <div class="available">
            <span>ご利用可能額</span>
            <span class="amount"
              >{{ numberWithDelimiter(membersIndex.available_credit)
              }}<span class="small">円</span></span
            >
          </div>
          <div class="_mb-20">
            <small
              >※お借り入れ金額は10,000円以上、10,000円単位となります。</small
            >
          </div>
          <div class="balance _mb-md-20 _mb-sm-10">
            <span
              >ご利用残高<br /><span class="small"
                >(ご利用限度額：{{
                  numberToCurrency(membersIndex.loan_credit_limit)
                }})</span
              ></span
            >
            <span class="amount">{{
              numberToCurrency(membersIndex.repayment_use_balance_principal)
            }}</span>
          </div>
          <!--<div class="upgrade _mb-sm-10">
            <btn-text router-name="sv036" class="-next" target="_blank">増枠をご希望のお客さまはこちら</btn-text>
          </div>-->
        </div>
        <div class="col-md-6 col-12 chart">
          <TableBox class="-members _mb-10">
            <TableBody>
              <TableRow>
                <TableHeader>次回ご返済日</TableHeader>

                <TableData
                  v-if="membersIndex.repayment_next_refund_amount > 0"
                  :class="{ block: isOverDue }"
                  >{{ ymdDateFormat(membersIndex.repayment_next_refund_period)
                  }}<span class="msg"
                    >返済の期日を過ぎています<br />ご返済方法については<router-link
                      :to="{ name: 'mb015' }"
                      class="-underline"
                      >こちら</router-link
                    ></span
                  ></TableData
                >
                <TableData v-else>-</TableData>
              </TableRow>
              <TableRow>
                <TableHeader>次回ご返済金額</TableHeader>
                <TableData
                  v-if="membersIndex.repayment_next_refund_amount > 0"
                  >{{
                    numberToCurrency(membersIndex.repayment_next_refund_amount)
                  }}</TableData
                >
                <TableData v-else>-</TableData>
              </TableRow>
            </TableBody>
          </TableBox>
          <!--<BtngroupSingle>-->
          <!--<BtnMain class="-normal" router-name="mb052">ご返済シミュレーション</BtnMain>-->
          <!--</BtngroupSingle>-->
        </div>
      </div>

      <div class="row -spnone cards _mb-60">
        <div class="col-6">
          <CardBox class="cb-borrow">
            <CardHeader>
              <h2 class="heading">お借り入れ</h2>
            </CardHeader>
            <CardBody>
              <div class="link">
                <template
                  v-if="
                    isProhibitedDeposit ||
                    isProhibitedPrepaid ||
                    isProhibitedGelato ||
                    isProhibitedWakai
                  "
                >
                  <a
                    class="atag disabled"
                    href="javascript:void(0)"
                    tabindex="-1"
                  >
                    <img
                      src="@/assets/images/header/mb-charge.svg"
                      class="icon"
                    />
                    au PAY 残高に<br />
                    チャージ
                  </a>
                </template>
                <template v-else>
                  <router-link
                    :to="{ name: 'mb012' }"
                    class="atag"
                    @click="
                      trackGtmEvent(
                        '【click】お借り入れボタン',
                        'お借り入れボタン,au PAYプリペイドカードにチャージ'
                      )
                    "
                  >
                    <img
                      src="@/assets/images/header/mb-charge.svg"
                      class="icon"
                    />
                    au PAY 残高に<br />
                    チャージ
                  </router-link>
                </template>
              </div>
              <div class="link">
                <template v-if="isProhibitedDeposit || isProhibitedSeven || isProhibitedWakai">
                  <a
                    class="atag disabled"
                    href="javascript:void(0)"
                    tabindex="-1"
                  >
                    <img
                      src="@/assets/images/header/mb-seven.svg"
                      class="icon"
                    />
                    セブン銀行<br />スマホATM
                  </a>
                </template>
                <template v-else>
                  <router-link
                    :to="{ name: 'sv025' }"
                    target="_blank"
                    class="atag"
                    @click="
                      trackGtmEvent(
                        '【click】お借り入れボタン',
                        'お借り入れボタン,セブン銀行スマホATM'
                      )
                    "
                  >
                    <img
                      src="@/assets/images/header/mb-seven.svg"
                      class="icon"
                    />
                    セブン銀行<br />スマホATM
                  </router-link>
                </template>
              </div>
              <div class="link">
                <template v-if="isProhibitedDeposit || isProhibitedSmbc || isProhibitedWakai">
                  <a
                    class="atag disabled"
                    href="javascript:void(0)"
                    tabindex="-1"
                  >
                    <img
                      src="@/assets/images/header/mb-bank.svg"
                      class="icon"
                    />
                    ご登録口座への<br />お振込み
                  </a>
                </template>
                <template v-else>
                  <router-link
                    :to="{ name: 'mb011' }"
                    class="atag"
                    @click="
                      trackGtmEvent(
                        '【click】お借り入れボタン',
                        'お借り入れボタン,ご登録口座へのお振込み'
                      )
                    "
                  >
                    <img
                      src="@/assets/images/header/mb-bank.svg"
                      class="icon"
                    />
                    ご登録口座への<br />お振込み
                  </router-link>
                </template>
              </div>
            </CardBody>
            <!--<div v-if="isOverDue" class="block">-->
            <!--<div class="inner">-->
            <!--返済を完了するまでお借り入れいただけません。-->
            <!--</div>-->
            <!--</div>-->
          </CardBox>
        </div>
        <div class="col-6">
          <CardBox class="cb-return">
            <CardHeader>
              <h2 class="heading">ご返済</h2>
            </CardHeader>
            <CardBody>
              <div class="link">
                <template v-if="isProhibitedWakai || isProhibitedSeven">
                  <a
                    class="atag disabled"
                    href="javascript:void(0)"
                    tabindex="-1"
                  >
                    <img
                      src="@/assets/images/header/mb-seven.svg"
                      class="icon"
                    />
                    セブン銀行<br />スマホATM
                  </a>
                </template>
                <template v-else>
                  <router-link
                    :to="{ name: 'sv029' }"
                    target="_blank"
                    class="atag"
                    @click="
                      trackGtmEvent(
                        '【click】ご返済ボタン',
                        'ご返済ボタン,セブン銀行スマホATM'
                      )
                    "
                  >
                    <img
                      src="@/assets/images/header/mb-seven.svg"
                      class="icon"
                    />
                    セブン銀行<br />スマホATM
                  </router-link>
                </template>
              </div>
              <div class="link">
                <router-link
                  :to="{ name: 'mb015' }"
                  class="atag"
                  @click="
                    trackGtmEvent(
                      '【click】ご返済ボタン',
                      'ご返済ボタン,指定口座へのお振込み'
                    )
                  "
                >
                  <img src="@/assets/images/header/mb-pay.svg" class="icon" />
                  指定口座への<br />
                  お振込み
                </router-link>
              </div>
            </CardBody>
          </CardBox>
        </div>
      </div>

      <CardGroups class="_mb-sm-40 _mb-md-60">
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="accordion1" class="-plus">
              <h2 class="heading">
                お借り入れ・ご返済時に便利な口座登録について
              </h2>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="accordion1" accordion="accordion1" :visible="true">
            <CardBody>
              <ListGroup class="-normal _mb-20">
                <ListItem class="-normal"
                  >お借り入れ時の口座への振込み手数料、ご返済時の口座からの引落し手数料は0円</ListItem
                >
                <ListItem class="-normal"
                  >毎月のご返済日に、口座からの自動引落しになるため、毎月忘れずにご返済いただけます。</ListItem
                >
              </ListGroup>
              <ListGroup class="-link">
                <ListItem
                  class="-link"
                  router-name="mb021"
                  @click="
                    trackGtmEvent(
                      '【click】便利な口座',
                      '便利な口座について,口座情報の登録・変更はこちら'
                    )
                  "
                  >口座情報の登録・変更はこちら</ListItem
                >
              </ListGroup>
            </CardBody>
          </CollapseItem>
        </CardBox>
      </CardGroups>
    </div>
    <hr />
    <div class="container campaign">
      <div
        v-if="campaignBannerList.length > 0"
        class="swiper-box _mb-10 _mt-25"
      >
        <!-- swiper -->
        <SwiperBanner
          :banner-list="campaignBannerList.slice(0, 3)"
          :event-list="campaignEventList"
        />
      </div>
      <BtngroupSingle>
        <BtnMain
          class="-normal"
          router-name="cp001"
          target="_blank"
          @click="
            trackGtmEvent('【click】キャンペーン一覧', 'キャンペーン一覧')
          "
        >
          キャンペーン一覧
        </BtnMain>
      </BtngroupSingle>
    </div>
    <QuestionareLink scroll-to="questionare">
      <span class="inline-md">au PAY スマートローン </span
      >アンケートご協力のお願い
    </QuestionareLink>
    <div class="container">
      <div class="how-to flex">
        <div class="card">
          <div class="card-body">
            <p class="card-title">
              <IconBox src="contract" class="-md -db"></IconBox>
              ご契約・お取引情報
            </p>
            <ListGroup variant="-link">
              <ListItem
                variant="-link"
                router-name="mb019"
                @click="
                  trackGtmEvent(
                    '【click】ご契約・お取引情報',
                    'ご契約・お取引情報,ご契約内容のご確認'
                  )
                "
                >ご契約内容のご確認</ListItem
              >
              <ListItem
                variant="-link"
                router-name="mb004"
                @click="
                  trackGtmEvent(
                    '【click】ご契約・お取引情報',
                    'ご契約・お取引情報,お取引履歴のご確認'
                  )
                "
                >お取引履歴のご確認</ListItem
              >
              <!--<ListItem variant="-link" router-name="sv036" class="-next" target="_blank">増枠をご希望のお客さまはこちら</ListItem>-->
              <ListItem
                variant="-link"
                router-name="mb020"
                @click="
                  trackGtmEvent(
                    '【click】ご契約・お取引情報',
                    'ご契約・お取引情報,ご契約締結書面一覧のご確認'
                  )
                "
                >ご契約締結書面一覧のご確認</ListItem
              >
            </ListGroup>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <p class="card-title">
              <IconBox src="customer" class="-md -db"></IconBox>
              ご登録情報
            </p>
            <ListGroup variant="-link">
              <ListItem
                variant="-link"
                router-name="mb023"
                @click="
                  trackGtmEvent(
                    '【click】ご登録情報',
                    'ご登録情報 ,お客さま情報の確認・変更'
                  )
                "
                >お客さま情報の確認・変更</ListItem
              >
              <ListItem
                variant="-link"
                router-name="mb021"
                @click="
                  trackGtmEvent(
                    '【click】ご登録情報',
                    'ご登録情報 ,口座情報の登録・変更'
                  )
                "
                >口座情報の登録・変更</ListItem
              >
              <ListItem
                variant="-link"
                router-name="mb032"
                @click="
                  trackGtmEvent(
                    '【click】ご登録情報',
                    'ご登録情報 ,暗証番号再設定'
                  )
                "
                >暗証番号再設定</ListItem
              >
              <ListItem
                variant="-link"
                router-name="mb026"
                @click="
                  trackGtmEvent(
                    '【click】ご登録情報',
                    'ご登録情報 ,メールアドレス・お知らせ通知設定の変更'
                  )
                "
                >メールアドレス・お知らせ通知設定の変更</ListItem
              >
            </ListGroup>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="guide container _mb-md-80 _mb-sm-60">
      <HeadingTwo>auサービスでもっとおトクに！</HeadingTwo>
      <div class="heading-sub">
        日々の暮らしをちょっとよくするおトクな情報をお知らせします。
      </div>
      <CardGroups class="-image-top-list">
        <CardBox
          router-name="sv016"
          class="-image-top -flex -next"
          target="_blank"
          @click="
            trackGtmEvent(
              '【click】auサービスコンテンツ',
              'auサービスでもっとおトクに！,Pontaポイントでスマートな暮らしを！'
            )
          "
        >
          <CardHeader>
            <CardImage
              ><img
                src="@/assets/images/mb/mb001/img01.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
          </CardHeader>
          <CardBody>Pontaポイントでスマートな暮らしを！</CardBody>
        </CardBox>
        <CardBox
          router-name="sv013"
          class="-image-top -flex -next"
          target="_blank"
          @click="
            trackGtmEvent(
              '【click】auサービスコンテンツ',
              'auサービスでもっとおトクに！,携帯電話の料金を見直しておトクに節約！'
            )
          "
        >
          <CardHeader>
            <CardImage
              ><img
                src="@/assets/images/mb/mb001/img02.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
          </CardHeader>
          <CardBody>携帯電話の料金を見直しておトクに節約！</CardBody>
        </CardBox>
        <CardBox
          router-name="sv014"
          class="-image-top -flex -next"
          target="_blank"
          @click="
            trackGtmEvent(
              '【click】auサービスコンテンツ',
              'auサービスでもっとおトクに！,auでんきでスマートに省エネ！Pontaポイントも貯まる！'
            )
          "
        >
          <CardHeader>
            <CardImage
              ><img
                src="@/assets/images/mb/mb001/img03.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
          </CardHeader>
          <CardBody
            >auでんきでスマートに省エネ！Pontaポイントも貯まる！</CardBody
          >
        </CardBox>
      </CardGroups>
    </div>
    <div class="news container _mb-md-80 _mb-sm-40">
      <HeadingTwo>お知らせ</HeadingTwo>
      <TabBordered :active="selectedTab">
        <TabHeader class="-md">
          <TabItem tab-name="tab01" @onclick="setTab">重要なお知らせ</TabItem>
          <TabItem tab-name="tab02" @onclick="setTab">トピックス</TabItem>
          <TabItem tab-name="tab03" @onclick="setTab">ニュースリリース</TabItem>
        </TabHeader>
        <TabBody tab-name="tab01">
          <template v-if="noticeList.length > 0">
            <ListGroup class="-link -visited _mb-md-60 _mb-sm-30">
              <ListItem
                v-for="(item, index) of noticeList.slice(0, 3)"
                :key="'topics' + index"
                class="-link"
                :href="item.url"
                target="_blank"
              >
                <span class="date">{{ item.display_date }}</span
                >{{ item.title }}
              </ListItem>
            </ListGroup>
          </template>
          <template v-else>
            <p>「重要なお知らせ」は、現在ございません。</p>
          </template>
          <BtngroupSingle>
            <BtnMain class="-normal" router-name="nw003" target="_blank">
              重要なお知らせ一覧
            </BtnMain>
          </BtngroupSingle>
        </TabBody>
        <TabBody tab-name="tab02">
          <template v-if="topicList.length > 0">
            <ListGroup class="-link -visited _mb-md-60 _mb-sm-30">
              <ListItem
                v-for="(item, index) of topicList.slice(0, 3)"
                :key="'topics' + index"
                class="-link"
                :href="item.url"
                target="_blank"
              >
                <span class="date">{{ item.display_date }}</span
                >{{ item.title }}
              </ListItem>
            </ListGroup>
          </template>
          <template v-else>
            <p>「TOPICS」は、現在ございません。</p>
          </template>
          <BtngroupSingle>
            <BtnMain class="-normal" router-name="nw001" target="_blank">
              トピックス一覧
            </BtnMain>
          </BtngroupSingle>
        </TabBody>
        <TabBody tab-name="tab03">
          <template v-if="newsList.length > 0">
            <ListGroup class="-link -visited _mb-md-60 _mb-sm-30">
              <ListItem
                v-for="(item, index) of newsList.slice(0, 3)"
                :key="'news' + index"
                class="-link"
                :href="item.url"
                target="_blank"
              >
                <span class="date">{{ item.display_date }}</span
                >{{ item.title }}
              </ListItem>
            </ListGroup>
          </template>
          <template v-else>
            <p>「ニュースリリース」は、現在ございません。</p>
          </template>
          <BtngroupSingle>
            <BtnMain class="-normal" router-name="nw005" target="_blank">
              ニュースリリース一覧
            </BtnMain>
          </BtngroupSingle>
        </TabBody>
      </TabBordered>
    </div>
    <hr />
    <div id="questionare" class="questionare container _mb-md-80 _mb-sm-60">
      <HeadingTwo>アンケート</HeadingTwo>
      <div class="heading-sub">
        日頃よりau PAY スマートローンをご利用いただきありがとうございます。<br />
        au PAY スマートローンではアンケートをお願いしております。<br />
        お答えしやすいカテゴリからご回答ください。
      </div>
      <ListGroup class="-note heading-text">
        <ListItem class="-note"
          >各アンケートは【5分程度】で完了する内容となっております。</ListItem
        >
        <ListItem class="-note">外部サイトへ遷移します。</ListItem>
      </ListGroup>
      <QuestionareList>
        <QuestionareItem href="https://questant.jp/q/profile_1st?id="
          >プロフィールについて①</QuestionareItem
        >
        <QuestionareItem href="https://questant.jp/q/profile_2nd?id="
          >プロフィールについて②</QuestionareItem
        >
        <QuestionareItem href="https://questant.jp/q/money_1st?id="
          >お金について①</QuestionareItem
        >
        <QuestionareItem href="https://questant.jp/q/money_2nd?id="
          >お金について②</QuestionareItem
        >
        <QuestionareItem href="https://questant.jp/q/style_of_life?id="
          >生活について</QuestionareItem
        >
        <QuestionareItem href="https://questant.jp/q/hobby?id="
          >趣味について</QuestionareItem
        >
      </QuestionareList>
      <ListGroup class="-note heading-text">
        <ListItem class="-note">
          アンケートにご協力いただきありがとうございます。<br />
          本アンケートの内容は、当社の個人情報保護方針、個人情報保護に関する公表事項、au
          PAY スマートローンの会員規約等の定めに従い利用させていただきます。
        </ListItem>
      </ListGroup>
    </div>
    <div class="guide-sp -pcnone">
      <TabSticky class="tab" :active="selectedFooterTab" :show="showFooterTab">
        <TabHeader>
          <TabItem tab-name="tab01" class="-orange" @onclick="setFooterTab"
            >お借り入れ</TabItem
          >
          <TabItem tab-name="tab02" class="-green" @onclick="setFooterTab"
            >ご返済</TabItem
          >
        </TabHeader>
        <TabBody tab-name="tab01" class="-orange" :sticky="true">
          <CardBox class="cb-borrow">
            <CardBody>
              <div class="link _mr-sm-5">
                <template v-if="isProhibitedDeposit || isProhibitedSeven || isProhibitedWakai">
                  <a
                    class="atag disabled"
                    href="javascript:void(0)"
                    tabindex="-1"
                  >
                    <img
                      src="@/assets/images/header/mb-seven.svg"
                      class="icon"
                    />
                    セブン銀行スマホATM
                  </a>
                </template>
                <template v-else>
                  <a
                    class="atag"
                    href="javascript:void(0)"
                    @click.prevent="launchApp('loan')"
                  >
                    <img
                      src="@/assets/images/header/mb-seven.svg"
                      class="icon"
                    />
                    セブン銀行スマホATM
                  </a>
                </template>
              </div>
              <div class="link _mx-sm-5">
                <template
                  v-if="
                    isProhibitedDeposit ||
                    isProhibitedPrepaid ||
                    isProhibitedGelato ||
                    isProhibitedWakai
                  "
                >
                  <a
                    class="atag disabled"
                    href="javascript:void(0)"
                    tabindex="-1"
                  >
                    <img
                      src="@/assets/images/header/mb-charge.svg"
                      class="icon"
                    />
                    au PAY 残高にチャージ
                  </a>
                </template>
                <template v-else>
                  <router-link :to="{ name: 'mb012' }" class="atag">
                    <img
                      src="@/assets/images/header/mb-charge.svg"
                      class="icon"
                    />
                    au PAY 残高にチャージ
                  </router-link>
                </template>
              </div>
              <div class="link _ml-sm-5">
                <template v-if="isProhibitedDeposit || isProhibitedSmbc || isProhibitedWakai">
                  <a
                    class="atag disabled"
                    href="javascript:void(0)"
                    tabindex="-1"
                  >
                    <img
                      src="@/assets/images/header/mb-bank.svg"
                      class="icon"
                    />
                    ご登録口座への<br />お振込み
                  </a>
                </template>
                <template v-else>
                  <router-link :to="{ name: 'mb011' }" class="atag">
                    <img
                      src="@/assets/images/header/mb-bank.svg"
                      class="icon"
                    />
                    ご登録口座への<br />お振込み
                  </router-link>
                </template>
              </div>
            </CardBody>
          </CardBox>
          <div class="close">
            <a class="atag" @click.prevent="hideFooterTab"
              ><img
                src="@/assets/images/icons/close-gray.svg"
                class="icon"
              />閉じる</a
            >
          </div>
        </TabBody>
        <TabBody tab-name="tab02" class="-green" :sticky="true">
          <CardBox class="cb-return">
            <CardBody>
              <div class="link _mr-sm-5">
                <template v-if="isProhibitedWakai || isProhibitedSeven">
                  <a
                    class="atag disabled"
                    href="javascript:void(0)"
                    tabindex="-1"
                  >
                    <img
                      src="@/assets/images/header/mb-seven.svg"
                      class="icon"
                    />
                    セブン銀行スマホATM
                  </a>
                </template>
                <template v-else>
                  <a
                    class="atag"
                    href="javascript:void(0)"
                    @click.prevent="launchApp('payback')"
                  >
                    <img
                      src="@/assets/images/header/mb-seven.svg"
                      class="icon"
                    />
                    セブン銀行スマホATM
                  </a>
                </template>
              </div>
              <div class="link _ml-sm-5">
                <router-link :to="{ name: 'mb015' }" class="atag">
                  <img src="@/assets/images/header/mb-pay.svg" class="icon" />
                  指定口座への<br />お振込み
                </router-link>
              </div>
            </CardBody>
          </CardBox>
          <div class="close">
            <a class="atag" @click.prevent="hideFooterTab"
              ><img
                src="@/assets/images/icons/close-gray.svg"
                class="icon"
              />閉じる</a
            >
          </div>
        </TabBody>
      </TabSticky>
    </div>
    <ModalWindow v-if="isShowModal" @close="hideModal">
      <div class="inner">
        <p class="title _mb-20">
          <IconBox src="exclamation" class="-w20"></IconBox
          >お客さま情報の一部が未登録となっております。
        </p>
        <p class="msg _mb-20">
          電話番号またはメールアドレスのご登録をお願いいたします。
        </p>
        <BtngroupSingle class="_mb-md-50 _mb-sm-30">
          <BtnMain class="-normal" router-name="mb023"
            >お客さま情報を確認・変更する</BtnMain
          >
        </BtngroupSingle>
        <BtngroupSingle>
          <BtnClose class="-close -md" @click.prevent="hideModal"
            >閉じる</BtnClose
          >
        </BtngroupSingle>
      </div>
    </ModalWindow>
  </div>
  <!-- container -->
</template>

<script>
import { membersIndexLambdaInvoke } from "@/utils/LambdaHelper";
import { launchApp } from "@/utils/ExternalScripts";
import {
  getUrgentList,
  getNoticeList,
  getTopicsList,
  getNewsList,
  getCampaignBannerList,
} from "@/utils/CmsHelper";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage } from "@/utils/Other";
import { trackGtmEvent } from "@/utils/Gtm";

import BadgeIcon from "@/components/badges/BadgeIcon";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CollapseItem from "@/components/collapse/CollapseItem";
import CardBody from "@/components/card/CardBody";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import BtnToggle from "@/components/button/BtnToggle";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import HeadingTwo from "@/components/heading/HeadingTwo";
import IconBox from "@/components/icons/IconBox";
import CardGroups from "@/components/card/CardGroups";
import CardImage from "@/components/card/CardImage";
import TabBordered from "@/components/tabs/TabBordered";
import TabHeader from "@/components/tabs/TabHeader";
import TabItem from "@/components/tabs/TabItem";
import TabBody from "@/components/tabs/TabBody";
import TabSticky from "@/components/tabs/TabSticky";
import ModalWindow from "@/components/modal/ModalWindow";
import BtnClose from "@/components/button/BtnClose";
import QuestionareLink from "@/components/link/QuestionareLink";
import QuestionareList from "@/components/contents/QuestionareList";
import QuestionareItem from "@/components/contents/QuestionareItem";
import SwiperBanner from "@/components/swiper/SwiperBanner";

import {
  numberToCurrency,
  numberWithDelimiter,
  ymdDateFormat,
} from "@/utils/Filter";

export default {
  name: "Mb001",
  components: {
    BtnClose,
    ModalWindow,
    TabSticky,
    TabBody,
    TabItem,
    TabHeader,
    TabBordered,
    CardImage,
    CardGroups,
    IconBox,
    HeadingTwo,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    BtnToggle,
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    CardBody,
    CollapseItem,
    CardHeader,
    CardBox,
    BadgeIcon,
    QuestionareLink,
    QuestionareList,
    QuestionareItem,
    SwiperBanner,
  },
  setup() {
    setMeta({
      title: "会員サイト",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト",
    });
    return {
      numberToCurrency,
      numberWithDelimiter,
      ymdDateFormat,
      trackGtmEvent,
    };
  },
  data() {
    return {
      urgentList: [],
      topicList: [],
      noticeList: [],
      newsList: [],
      campaignBannerList: [],
      campaignEventList: [
        { category: "【click】広告バナー", action: "広告バナー１枠目" },
        { category: "【click】広告バナー", action: "広告バナー２枠目" },
        { category: "【click】広告バナー", action: "広告バナー３枠目" },
      ],
      isShowModal: false,
      membersIndex: {
        account_id: "",
        name_kanji: "",
        firstname_kanji: "",
        lastname_kanji: "",
        available_credit: "",
        repayment_use_balance_principal: "",
        loan_credit_limit: "",
        repayment_next_refund_period: "",
        repayment_next_refund_amount: "",
        delayed_days: "",
        phone_au_1: "",
        phone_au_2: "",
        phone_au_3: "",
        phone_mobile_1: "",
        phone_mobile_2: "",
        phone_mobile_3: "",
        ez_mail: "",
        mail_1: "",
        mail_2: "",
        loan_mail: "",
        notices: [],
      },
      newMessageCount: "",
      isEmergency: false,
      isOverDue: false,
      selectedTab: "tab01",
      selectedFooterTab: "tab01",
      showFooterTab: false,
    };
  },
  computed: {
    isProhibitedDeposit() {
      return this.$store.getters.isProhibitedDeposit;
    },
    isProhibitedPrepaid() {
      return this.$store.getters.isProhibitedPrepaid;
    },
    isProhibitedSmbc() {
      return this.$store.getters.isProhibitedSmbc;
    },
    isProhibitedGelato() {
      return this.$store.getters.isProhibitedGelato;
    },
    isProhibitedSeven() {
      return this.$store.getters.isProhibitedSeven;
    },
    isProhibitedWakai () {
      return this.$store.getters.isProhibitedWakai
    },
    coveredName() {
      const firstname = [...this.membersIndex.firstname_kanji].map((v, i) => {
        i++;
        if (i % 2 === 0) {
          return (v = "*");
        } else {
          return v;
        }
      }).join('');
      const lastname = [...this.membersIndex.lastname_kanji].map((v, i) => {
        i++;
        if (i % 2 !== 0) {
          return (v = "*");
        } else {
          return v;
        }
      }).join('');
      return lastname + "　" + firstname;
    },
  },
  mounted() {
    membersIndexLambdaInvoke()
      .then((res) => {
        let resBody = JSON.parse(res.body);
        for (let key in resBody) {
          if (Object.prototype.hasOwnProperty.call(this.membersIndex, key)) {
            this.membersIndex[key] = resBody[key];
          }
        }
        this.isOverDue =
          !!this.membersIndex.delayed_days &&
          this.membersIndex.delayed_days > 0;
        this.sortNotice();
        this.setNewMessageCount();
        this.setShowModal();
      })
      .catch((error) => {
        goToErrorPage(error);
      });
    getUrgentList()
      .then((res) => {
        this.urgentList = res.urgent || [];
        this.isEmergency = this.urgentList.length > 0;
      })
      .catch((error) => {
        goToErrorPage(error);
      });
    getTopicsList()
      .then((res) => {
        this.topicList = res.topics || [];
      })
      .catch((error) => {
        goToErrorPage(error);
      });
    getCampaignBannerList()
      .then((res) => {
        this.campaignBannerList = res.campaign_banner || [];
      })
      .catch((error) => {
        goToErrorPage(error);
      });
    getNoticeList()
      .then((res) => {
        this.noticeList = res.notice || [];
      })
      .catch((error) => {
        goToErrorPage(error);
      });
    getNewsList()
      .then((res) => {
        this.newsList = res.news || [];
      })
      .catch((error) => {
        goToErrorPage(error);
      });
  },
  methods: {
    closeMessage: function () {
      this.$parent.$parent.visible = false;
    },
    windowClose: function () {
      window.close();
      alert("javascriptでwindowは閉じられません");
    },
    hideTransferSettingModal: function () {
      this.$root.$emit("bv::hide::modal", "transferSettingModal");
    },
    hideModal() {
      this.isShowModal = false;
    },
    sortNotice() {
      this.membersIndex.notices.sort(function (a, b) {
        // 未読 > 日付
        if (a.disp_status < b.disp_status) return -1;
        if (a.disp_status > b.disp_status) return 1;
        if (a.notice_date < b.notice_date) return 1;
        if (a.notice_date > b.notice_date) return -1;
        return 0;
      });
    },
    setNewMessageCount() {
      let unreadNoticecs = this.membersIndex.notices.filter(function (notice) {
        return notice.disp_status === "0";
      });
      this.newMessageCount = unreadNoticecs.length;
    },
    setTab(tabName) {
      this.selectedTab = tabName;
    },
    setFooterTab(tabName) {
      this.showFooterTab = true;
      this.selectedFooterTab = tabName;
    },
    setShowModal() {
      this.isShowModal =
        (!this.membersIndex.phone_au_1 &&
          !this.membersIndex.phone_au_2 &&
          !this.membersIndex.phone_au_3 &&
          !this.membersIndex.phone_mobile_1 &&
          !this.membersIndex.phone_mobile_2 &&
          !this.membersIndex.phone_mobile_3) ||
        (!this.membersIndex.ez_mail &&
          !this.membersIndex.mail_1 &&
          !this.membersIndex.mail_2 &&
          !this.membersIndex.loan_mail);
    },
    hideFooterTab() {
      this.showFooterTab = false;
    },
    launchApp(host) {
      launchApp(host);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.mb001 {
  position: relative;
  top: -20px;
  > .emergency {
    background-color: $red;
    > .inner {
      margin: 0 auto;
      color: $danger;
      padding: 20px;
      font-size: 14px;
      @include mq-up(md) {
        @include flex(flex, flex-start, center, row, nowrap);
        padding: 20px 0;
        font-size: 16px;
      }
      > .messages {
        display: block;
        > .message {
          margin-top: 10px;
          &:first-child {
            margin-top: 0px;
          }
          > .link {
            color: $white;
            text-decoration: underline;
          }
          .date {
            display: block;
            font-size: 12px;
            @include mq-up(md) {
              font-size: 14px;
            }
          }
        }
      }
      > .badge-icon {
        font-size: 12px;
        margin-bottom: 10px;
        background-color: $white;
        color: $red;
        @include mq-up(md) {
          font-size: 14px;
          margin: 0 20px;
        }
        > .icon {
          width: 14px;
        }
      }
    }
  }
  > .message {
    padding: 30px 0;
    background-color: $medium;
    > .inner {
      > .card-box {
        background-color: $white;
        border: none;
        > .card-header {
          @include mq-up(md) {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          }
          > .heading {
            font-weight: normal;
            font-size: 12px;
            @include mq-up(md) {
              font-size: 20px;
            }
            > .name {
              font-size: 16px;
              @include mq-up(md) {
                font-size: 24px;
              }
            }
          }
          > .number {
            font-size: 10px;
            font-weight: normal;
            color: $gray;
            @include mq-up(md) {
              font-size: 16px;
            }
          }
        }
        > .card-box {
          border: none;
          > .card-header {
            border-radius: 0;
            border-top: 1px solid $secondary;
            > .btn-toggle {
              display: flex;
              justify-content: center;
              > .heading {
                font-weight: normal;
                .count {
                  padding-left: 10px;
                  color: $danger;
                  font-weight: bold;
                }
                > .new {
                  display: none;
                }
                > .close {
                  display: inline-block;
                }
              }
              &.collapsed {
                > .heading {
                  > .close {
                    display: none;
                  }
                  > .new {
                    display: inline-block;
                  }
                }
              }
            }
          }
          .card-body {
            padding-bottom: 0;
          }
        }
      }
    }
  }
  > .main {
    background-color: $white;
    > .stat {
      display: inline-block;
      font-size: 14px;
      background-color: $orange;
      color: $white;
      text-align: center;
      padding: 5px 15px;
      @include mq-up() {
        font-size: 16px;
        padding: 5px 30px;
      }
    }
    .available {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      @include mq-up() {
        font-size: 20px;
      }
      > .amount {
        font-size: 36px;
        font-weight: bold;
        > .small {
          font-size: 16px;
          font-weight: normal;
        }
        @include mq-up() {
          font-size: 56px;
          > .small {
            font-size: 24px;
          }
        }
      }
    }
    .balance {
      padding: 10px 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: $success;
      color: $orange;
      font-size: 14px;
      .small {
        display: block;
        color: $gray;
        font-size: 10px;
      }
      > .amount {
        color: $black;
        font-size: 18px;
      }
      @include mq-up() {
        padding: 10px 20px;
        border-radius: 10px;
        font-size: 18px;
        .small {
          font-size: 14px;
        }
        > .amount {
          font-size: 24px;
        }
      }
    }
    .upgrade {
      text-align: right;
      @include mq-up() {
        text-align: left;
      }
    }
    .chart {
      .table-header {
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 14px;
        vertical-align: middle;
        @include mq-up() {
          padding-top: 20px;
          padding-bottom: 20px;
          font-size: 18px;
        }
      }
      .table-header {
        @include mq-down() {
          padding-left: 10px;
          padding-right: 5px;
        }
      }
      .table-data {
        font-size: 18px;
        @include mq-down() {
          padding-left: 5px;
          padding-right: 10px;
        }
        @include mq-up() {
          font-size: 24px;
        }
        > .msg {
          display: none;
        }
        .-underline {
          color: $danger;
          text-decoration: underline;
        }
        &.block {
          color: $danger;
          > .msg {
            display: block;
            font-size: 12px;
            @include mq-up() {
              font-size: 16px;
            }
          }
        }
      }
      .notice {
        color: $gray;
        font-size: 10px;
        @include mq-up() {
          font-size: 14px;
        }
        > .small {
          @include mq-up() {
            font-size: 14px;
          }
        }
      }
      .buttons {
        display: flex;
        justify-content: space-between;
        @include mq-up() {
          justify-content: flex-end;
        }
        .btn-main {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          line-height: 18px;
          padding: 10px 0;
          background-position: right 10px center;
          @include mq-up() {
            background-position: right 15px center;
            display: inline-block;
            font-size: 16px;
            line-height: 24px;
            margin-left: 15px;
            padding: 8px 0;
          }
        }
      }
    }
    .cards {
      .card-box {
        border: none;
        > .card-header {
          text-align: center;
          padding: 10px 0;
          > .heading {
            color: $white;
            font-weight: normal;
            font-size: 20px;
          }
        }
        > .card-body {
          border-radius: 0 0 10px 10px;
          padding: 20px;
          display: flex;
          justify-content: space-between;
          > .link {
            > .atag {
              display: block;
              width: 170px;
              height: 180px;
              border: 1px solid $secondary;
              border-radius: 10px;
              background-color: $white;
              text-align: center;
              font-size: 16px;
              padding: 20px 10px;
              > .icon {
                display: block;
                margin: 0 auto 10px;
                width: 80px;
              }
              &:hover {
                text-decoration: underline;
                > .icon {
                  opacity: 0.7;
                }
              }
              &.disabled {
                cursor: not-allowed;
                background: $secondary;
                color: #9a9a9a;
                > .icon {
                  opacity: 0.3;
                }
              }
              &.disabled:hover {
                text-decoration: none;
              }
            }
          }
        }
        &.cb-borrow {
          position: relative;
          .card-header {
            background-color: $orange;
          }
          .card-body {
            background-color: $success;
          }
          > .block {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            > .inner {
              position: absolute;
              width: 100%;
              height: 50%;
              top: 30%;
              border: 1px solid $danger;
              border-radius: 10px;
              background-color: rgba($white, 0.8);
              color: $danger;
              font-weight: bold;
              font-size: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
        &.cb-return {
          .card-header {
            background-color: $green;
          }
          .card-body {
            background-color: $twilight;
            justify-content: center;
            > .link {
              margin: 0 8px;
            }
          }
        }
      }
      .notice {
        columns: $medium;
        font-size: 14px;
        color: $gray;
      }
    }
  }
  > .campaign {
    padding-top: 10px;
    padding-bottom: 50px;
    > .heading-two {
      margin-bottom: 15px;
    }
    @include mq-up() {
      padding-bottom: 70px;
      > .heading-two {
        margin-bottom: 30px;
      }
    }
  }
  .how-to {
    padding-top: 40px;
    padding-bottom: 10px;
    @include mq-up(md) {
      padding-top: 80px;
      padding-bottom: 80px;
    }
    &.flex {
      align-items: flex-start;
      @include mq-down(md) {
        flex-wrap: wrap;
      }
    }
    .card {
      max-width: 560px;
      width: 100%;
      .card-body {
        > .card-title {
          font-size: 18px;
          line-height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 0;
          padding-bottom: 30px;
          border-bottom: 2px solid $primary;
          @include mq-up(md) {
            font-size: 32px;
          }
          .icon-box {
            width: 35px;
            margin-right: 10px;
            @include mq-up(md) {
              width: 40px;
            }
          }
        }
        > .list-group {
          @include mq-down(md) {
            margin-bottom: 40px;
          }
          .list-item {
            &.-link:first-child {
              border-top: $secondary dotted 0px;
            }
            .atag {
              &:hover {
                color: $black;
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
  }
  > .questionare-link {
    > .inner {
      > .text {
        > .inline-md {
          display: block;
          @include mq-up(md) {
            display: inline;
          }
        }
      }
    }
  }
  > .guide {
    padding-top: 10px;
    > .heading-two {
      margin-bottom: 15px;
      @include mq-up(md) {
        padding-top: 20px;
        margin-bottom: 25px;
      }
    }
    > .heading-sub {
      text-align: center;
      margin-bottom: 25px;
      font-size: 12px;
      @include mq-up(md) {
        margin-bottom: 40px;
        font-size: 16px;
      }
    }
    > .card-groups.-image-top-list {
      > .card-box.-image-top {
        margin-bottom: 30px;
        .card-header {
          margin-bottom: 15px;
        }
        .card-body {
          font-size: 16px;
          color: $black;
        }
        @include mq-down(md) {
          margin-bottom: 20px;
          border-bottom: 1px dotted $secondary;
          &:first-child {
            padding-top: 20px;
            border-top: 1px dotted $secondary;
          }
          .card-header {
            width: 50%;
          }
          .card-body {
            width: 50%;
            padding-right: 10px;
            padding-left: 10px;
            font-size: 14px;
            line-height: 22px;
          }
        }
      }
    }
  }
  > .questionare {
    padding-top: 10px;
    > .heading-two {
      margin-bottom: 15px;
      @include mq-up(md) {
        padding-top: 20px;
        margin-bottom: 35px;
      }
    }
    > .heading-sub {
      margin-bottom: 25px;
      font-size: 12px;
      @include mq-up(md) {
        margin-bottom: 20px;
        font-size: 16px;
      }
    }
    > .heading-text {
      margin-bottom: 20px;
      font-size: 12px;
      @include mq-up(md) {
        margin-bottom: 20px;
        font-size: 14px;
      }
    }
  }
  > .news {
    .tab-bordered {
      .tab-body {
        > .list-group {
          > .list-item {
            > .atag {
              > .date {
                display: block;
                margin-bottom: 10px;
              }
            }
          }
        }
      }
    }
  }
  > .guide-sp {
    width: 100%;
    margin: 0;
    padding: 0;
    > .tab-sticky {
      > .tab-body {
        > .close {
          text-align: center;
          padding: 15px 0 5px;
          > .atag {
            display: flex;
            justify-content: center;
            align-items: center;
            > .icon {
              width: 14px;
              margin-right: 5px;
              vertical-align: middle;
            }
          }
        }
        &.-orange {
          background-color: $success;
        }
        &.-green {
          background-color: $twilight;
        }
        .card-box {
          border: none;
          > .card-body {
            border-radius: 0 0 10px;
            padding: 0;
            display: flex;
            justify-content: center;
            > .link {
              max-width: 115px;
              width: 33.33333%;
              > .atag {
                height: 150px;
                width: 100%;
                border: 1px solid $secondary;
                border-radius: 10px;
                padding: 15px 2px;
                background-color: $white;
                line-height: 16px;
                display: inline-block;
                text-align: center;
                @include mq-up(md) {
                  width: 130px;
                  padding: 15px 10px;
                }
                > .icon {
                  display: block;
                  margin: 0 auto 10px;
                  width: 50px;
                }
                &.disabled {
                  background-color: $secondary;
                  color: #9a9a9a;
                  > .icon {
                    opacity: 0.3;
                  }
                }
                &.disabled:hover {
                  text-decoration: none;
                  > .icon {
                    opacity: 0.3;
                  }
                }
              }
            }
          }
          &.cb-borrow {
            position: relative;
            .card-header {
              background-color: $orange;
            }
            .card-body {
              background-color: $success;
              font-size: 12px;
              line-height: 14px;
            }
          }
          &.cb-return {
            .card-header {
              background-color: $green;
            }
            .card-body {
              background-color: $twilight;
              font-size: 12px;
              line-height: 14px;
              justify-content: center;
              > .link {
                margin: 0 8px;
              }
            }
          }
        }
      }
    }
  }
  > .modal-window {
    z-index: 9999;
    text-align: center;
    background-color: rgba($black, 0.6);
    > .panelouter {
      > .panel {
        > .inner {
          padding: 20px;
          > .title {
            font-size: 16px;
            font-weight: bold;
            color: $danger;
            display: flex;
            align-items: center;
            justify-content: center;
            > .icon-box {
              padding-right: 5px;
            }
          }
          @include mq-up(md) {
            > .title {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
@import "../assets/stylesheets/styles";
/*スライダー部分*/
.swiper-box {
  position: relative;
  .swiper-container {
    max-width: 1100px;
    padding-bottom: 30px;
    @include mq-up(md) {
      padding-bottom: 60px;
    }
  }
  .swiper-pagination-bullet-active {
    background-color: $primary;
  }

  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
  }

  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 7px;
    @include mq-up(md) {
      bottom: 26px;
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    margin-top: -54px;
    @include mq-down(md) {
      display: none;
    }
  }
  .swiper-button-prev {
    background-image: url("../assets/images/icons/arrow-left-swiper.svg");
    background-size: 20px 33px;
    left: -5px;
  }
  .swiper-button-next {
    background-image: url("../assets/images/icons/arrow-right-swiper.svg");
    background-size: 20px 33px;
    right: -5px;
  }
  .-over {
    &:hover {
      opacity: 0.75;
    }
  }
}
</style>
